import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { JSONSupport as r } from "../core/JSONSupport.js";
import { property as t } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { reader as o } from "../core/accessorSupport/decorators/reader.js";
import { subclass as s } from "../core/accessorSupport/decorators/subclass.js";
import a from "./SpatialReference.js";

var c = /*#__PURE__*/function (_r) {
  _inherits(c, _r);

  var _super = _createSuper(c);

  function c() {
    var _this;

    _classCallCheck(this, c);

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(e)), _this.type = null, _this.hasM = !1, _this.hasZ = !1, _this.spatialReference = a.WGS84;
    return _this;
  }

  _createClass(c, [{
    key: "cache",
    get: function get() {
      return this.commitProperty("spatialReference"), {};
    }
  }, {
    key: "extent",
    get: function get() {
      return null;
    }
  }, {
    key: "readSpatialReference",
    value: function readSpatialReference(e, r) {
      if (e instanceof a) return e;

      if (null != e) {
        var _t = new a();

        return _t.read(e, r), _t;
      }

      return e;
    }
  }, {
    key: "clone",
    value: function clone() {
      return console.warn(".clone() is not implemented for " + this.declaredClass), null;
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this.notifyChange("cache");
    }
  }, {
    key: "getCacheValue",
    value: function getCacheValue(e) {
      return this.cache[e];
    }
  }, {
    key: "setCacheValue",
    value: function setCacheValue(e, r) {
      this.cache[e] = r;
    }
  }]);

  return c;
}(r);

e([t()], c.prototype, "type", void 0), e([t({
  readOnly: !0
})], c.prototype, "cache", null), e([t({
  readOnly: !0
})], c.prototype, "extent", null), e([t({
  type: Boolean,
  json: {
    write: {
      overridePolicy: function overridePolicy(e) {
        return {
          enabled: e
        };
      }
    }
  }
})], c.prototype, "hasM", void 0), e([t({
  type: Boolean,
  json: {
    write: {
      overridePolicy: function overridePolicy(e) {
        return {
          enabled: e
        };
      }
    }
  }
})], c.prototype, "hasZ", void 0), e([t({
  type: a,
  json: {
    write: !0
  }
})], c.prototype, "spatialReference", void 0), e([o("spatialReference")], c.prototype, "readSpatialReference", null), c = e([s("esri.geometry.Geometry")], c);
var p = c;
export { p as default };